import axios from 'axios';

const CHECK_CUSTOM_ENVIRONMENT_QUERY = `
  query {
    __typename
  }
`;

export const checkCustomEnvironmentRequest = async (url: string, apiKey?: string): Promise<boolean> => {
  try {
    const response = await axios.post(
      url,
      { query: CHECK_CUSTOM_ENVIRONMENT_QUERY },
      { headers: { 'x-api-key': apiKey } }
    );

    return Boolean(response.status === 200 && response.data.data);
  } catch (_error) {
    return false;
  }
};
